import React from 'react';
import './JasMinerTopProducts.css';

import ProductImage1 from '../../../../assets/JasMiner/JasminerX4-3U-1.png'; // Import your images here
import ProductImage2 from '../../../../assets/JasMiner/X16.png'; 
import ProductImage3 from '../../../../assets/JasMiner/JASMINERX4MINI.png'; 
import ProductImage4 from '../../../../assets/JasMiner/JASMINERX4.png'; 
import ProductImage5 from '../../../../assets/JasMiner/JasminerX4-3U-1.png'; 

const products = [
  { name: 'JASMINER X4-Q-3U', price: '49 990 SEK' },
  { name: 'JASMINER X16-P', price: '119 990 SEK' },
  { name: 'JASMINER X4 MINI', price: '4990 SEK' },
  { name: 'Jas Miner X4', price: '49 990 SEK' },
  { name: 'Jas Miner X4-3U-Z', price: '19 990 SEK' },
];
const images = [ProductImage1, ProductImage2, ProductImage3, ProductImage4, ProductImage5];

const JasMinerTopProductComponent = () => {
  return (
    <div className="mine-thunder-jas-miner-jm-products-container">
      <h2 className="mine-thunder-jas-miner-jm-products-title">
        Top Products
      </h2>
      <h1 className="mine-thunder-jas-miner-jm-products-big-title">
        Jas Miner
      </h1>
      <div className="mine-thunder-jas-miner-jm-products">
        {products.map((product, index) => (
          <div
            className={`mine-thunder-jas-miner-jm-product-${index + 1}`}
            key={index}
          >
            <div className="product-container">
              <img
                src={images[index]}
                alt={`Product ${index + 1}`}
                className="mine-thunder-jas-miner-product-image"
              />
              <div className="product-details">
                <h3 className="mine-thunder-jas-miner-product-title">
                  {product.name}
                </h3>
                <p className="mine-thunder-jas-miner-product-price">
                  Price: {product.price}
                </p>
                <a
                  href={`link-to-${product.name}`}
                  className="mine-thunder-jas-miner-view-details"
                >
                  View Details
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
      <a href='/JasMiner' className='mine-thunder-jas-miner-See-More-Products-jas-miner'>See More Products</a>
    </div>
  );
};

export default JasMinerTopProductComponent;
